import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M7 5H2v14h5V5zm14 0h-5v14h5V5zm-7 0H9v14h5V5z"
}), 'ViewWeekSharp');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/ViewWeekSharp.js
// module id = 7128
// module chunks = 2